import { Unternehmen } from '../types';

export default function getVersicherungAnzeigeText(versicherung: Unternehmen | null): string {
  return versicherung ? `${versicherung?.firmenname ?? ''} ${versicherung?.strasse ?? ''} ${versicherung?.plz ?? ''} ${versicherung?.ort ?? ''}`.trim() : '';
}
